module.exports = __webpack_public_path__ + "static/SimeonB-46a5cba8e00682f7921a19d00315d426.gif";